module.exports = __webpack_public_path__ + "media/images/logos/TheEdge-logo-cc6e1ff34848c4808411ce46c90ea367.png";